// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1o2hM","question":"styles_question__3wZm4","inputVisibleButton":"styles_inputVisibleButton__GtguZ","note":"styles_note__1MXKd"};